export default __webpack_public_path__ + "static/media/mosaic_banner.bf40073b.png";